import React from "react";
import PropTypes from "prop-types";
import { FaCheck } from "react-icons/fa";

const STEPS = [
  { key: "address", label: "1. Endereço" },
  { key: "card", label: "2. Dados do cartão" },
];

export default function CardStepsHeader({ currentStep }) {
  const primaryColor = "var(--button-primary-color)";

  return (
    <div
      className="d-flex mb-4"
      style={{
        borderBottom: "1px solid #e0e0e0",
        marginLeft: "-1rem",
        marginRight: "-1rem",
      }}
    >
      {STEPS.map((step) => {
        const isActive = step.key === currentStep;
        const isCompleted = step.key === "address" && currentStep === "card";

        const color = isActive
          ? primaryColor
          : isCompleted
            ? "#2D8D68"
            : "#9e9e9e";

        return (
          <div
            key={step.key}
            className="d-flex align-items-center justify-content-center gap-1 pb-2"
            style={{
              flex: 1,
              fontSize: "13px",
              fontWeight: 600,
              color,
              borderBottom: isActive
                ? `2px solid ${primaryColor}`
                : "2px solid transparent",
            }}
          >
            {isCompleted && <FaCheck size={11} />}
            {step.label}
          </div>
        );
      })}
    </div>
  );
}

CardStepsHeader.propTypes = {
  currentStep: PropTypes.oneOf(["address", "card"]).isRequired,
};
